// extracted by mini-css-extract-plugin
export default {"card":"Card_card__4-jbm","title":"Card_title__HynCQ","content":"Card_content__HOJRd"};